import React from 'react';
import styled from '@emotion/styled';
import Markdown from 'react-markdown';
import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/react-hooks';

import DismissableBanner from './DismissableBanner';
import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';
import HandOffLink from '../../../utils/urls/HandOffLink';

const Paragraph = styled.p`
  margin: 0;
`;

const StyledLink = styled(HandOffLink)`
  text-decoration: underline;
  color: inherit;
`;

const StyledMarkdown = styled(Markdown)`
  color: ${({ color }) => color};
  text-align: center;
`;

const Banner = styled(DismissableBanner)`
  width: 100%;
  margin: 0;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 1rem;
    line-height: 1.25rem;
  }
`;

const GLOBAL_PROMO_QUERY = gql`
  {
    globalPromo {
      markdown
      backgroundColor
      textColor
    }
  }
`;

function GlobalPromo() {
  const { loading, error, data = {} } = useQuery(GLOBAL_PROMO_QUERY);

  if (loading || error || !data.globalPromo) return null;

  const { globalPromo } = data;
  const { markdown, backgroundColor, textColor } = globalPromo;

  const markdownConfig = {
    allowedTypes: ['text', 'paragraph', 'link', 'strong'],
    renderers: {
      link: props => <StyledLink {...props} identifier="global-promo" />,
      paragraph: props => <Paragraph {...props} />,
    },
    unwrapDisallowed: true,
  };

  return (
    <Banner
      dismissable={false}
      visible={true}
      color={backgroundColor}
      strokeColor={textColor}
      messageId="global-promo"
    >
      <StyledMarkdown {...markdownConfig} source={markdown} color={textColor} />
    </Banner>
  );
}

export default React.memo(GlobalPromo);
